import React, {useState} from 'react'
import {LANGUAGES} from "../../../../mock/languages";
import {Link, useParams} from "react-router-dom";
import {useNotification} from "../../../../context/NotificationContext";
import {lang} from "../../../../types/lang";
import {useFormik} from "formik";
import {UploadImage} from "../../../../components/common/uploadImage/UploadImage";
import {createTest, getTestById, getTests, updateTest} from "../../../../services/testSvc";
import {useQuery} from "react-query";
import imgBaseUrl from "../../../../utils/imgBaseUrl";
import {KTIcon} from "../../../../../_metronic/helpers";
import {useDeleteModal} from "../../../../context/DeleteModalContext";
import {MODERATOR_TEST} from "../../../../mock/URLs";
import {Pagination} from "../../../../components/common/pagination/Pagination";
import {LoaderSection} from "../../../../components/sections/loader/Loader";

export const TestCreatePage = () => {
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");
  const {lessonId, courseId} = useParams()
  const [selectedTest, setSelectedTest] = useState(null)

  const {
    data: testData,
    refetch: refetchTest
  } = useQuery(["getTests", lessonId], () => getTests({params: {lesson: Number(lessonId)}}), {
    enabled: !!lessonId
  })

  const {
    data: testById,
    isLoading: testByIdIsLoading
  } = useQuery(["getTestById", selectedTest], () => getTestById(selectedTest!), {
    enabled: !!selectedTest
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: {
        uz: testById?.title_uz || '',
        ru: testById?.title_ru || '',
        en: testById?.title_en || '',
      },
      description: {
        uz: testById?.description_uz || '',
        ru: testById?.description_ru || '',
        en: testById?.description_en || '',
      },
      lesson: lessonId!,
      banner: null,
      is_active: testById?.is_active || true
    },
    onSubmit: async (values, {
      resetForm
    }) => {
      try {
        const formData = new FormData();
        formData.append('title_uz', values.title.uz);
        formData.append('title_ru', values.title.ru);
        formData.append('title_en', values.title.en);
        formData.append('description_uz', values.description.uz);
        formData.append('description_ru', values.description.ru);
        formData.append('description_en', values.description.en);
        formData.append('lesson', values.lesson);
        formData.append('is_active', values.is_active.toString());

        if (values.banner) {
          formData.append('banner', values.banner!);
        }

        if (selectedTest) {
          const res = await updateTest(selectedTest, formData)
          if (res.success) {
            showNotification("Muvaffaqiyatli", "Test yangilandi", "success")
          }
        } else {
          const res = await createTest(formData)
          if (res.success) {
            showNotification("Muvaffaqiyatli", "Test qo'shildi", "success")
          }
        }
        refetchTest();
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  })

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_TEST, id, refetchTest);
  };

  const totalItems = testData?.total_items || 0;
  const itemsPerPage = testData?.page_size || 8;


  return (
      <div className={"container-fluid mb-10"}>
        <div className="card">
          <div className="card-header">
            <h1 className="card-title">
              Test qo'shish
            </h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <div className="card-body">
            {testByIdIsLoading ? <LoaderSection height={"50vh"}/> :
                <div id="kt_account_profile_details" className="collapse show">
                  <form
                      className="form"
                      onSubmit={formik.handleSubmit}
                      encType="multipart/form-data"
                  >
                    <div className="card-body p-9">
                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Test nomi
                        </label>
                        <div className="col-lg-8">
                          <input name={
                            `title[${activeTab}]`
                          } type="text" value={formik.values.title[activeTab]}
                                 onChange={formik.handleChange}
                                 onBlur={formik.handleBlur}
                                 className={"form-control form-control-solid"}
                                 placeholder="Test nomi"
                          />
                          {formik.touched.title && formik.errors.title && (
                              <div className="invalid-feedback">{formik.errors.title[activeTab]}</div>
                          )}
                        </div>
                      </div>
                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Test tavsifi
                        </label>
                        <div className="col-lg-8">
                          <input name={
                            `description[${activeTab}]`
                          } type="text" value={formik.values.description[activeTab]}
                                 onChange={formik.handleChange}
                                 onBlur={formik.handleBlur}
                                 className={"form-control form-control-solid"}
                                 placeholder="Test tavsifi"
                          />
                          {formik.touched.description && formik.errors.description && (
                              <div className="invalid-feedback">{formik.errors.description[activeTab]}</div>
                          )}
                        </div>
                      </div>

                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Banner rasmi
                        </label>
                        <div className="col-lg-8 fv-row">
                          <UploadImage
                              imageSizes={"banner"}
                              onImageUpload={(file) => {
                                if (file) {
                                  formik.setFieldValue('banner', file);
                                }
                              }}/>
                          {formik.touched.banner && formik.errors.banner && (
                              <div className="text-danger">{formik.errors.banner}</div>
                          )}
                        </div>
                      </div>


                      <div className="row mb-6 d-flex align-items-center">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Holati
                        </label>
                        <div className="col-lg-8">
                          <label className="form-check form-check-inline form-check-solid">
                            <input name={
                              `is_active`
                            } type="checkbox" checked={formik.values.is_active}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   className={"form-check-input"}
                            /><span className={"fw-bold ps-2 fs-6"}>Aktiv</span>
                          </label>
                          {formik.touched.is_active && formik.errors.is_active && (
                              <div className="invalid-feedback">{formik.errors.is_active}</div>
                          )}
                        </div>
                      </div>


                    </div>
                    <div className="card-footer">
                      <div className="justify-content-end d-flex gap-2">
                        <button
                            className="btn btn-secondary"
                            onClick={() => {
                              formik.resetForm()
                              setSelectedTest(null)
                            }}
                            type="button"
                        >
                          Bekor qilish
                        </button>
                        <button
                            className="btn btn-primary"
                            type="submit"
                        >
                          Qo'shish
                        </button>
                      </div>
                    </div>
                  </form>
                </div>}
          </div>
        </div>

        <div className="card mt-10">
          <div className="card-header">
            <h1 className="card-title">
              Mavjud testlar
            </h1>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-row-dashed table-bordered table-hover">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Banner</th>
                  <th>Nomi</th>
                  <th>Tavsifi</th>
                  <th>Holati</th>
                  <th>Savollar soni</th>
                  <th>Amallar</th>
                </tr>
                </thead>
                <tbody>
                {testData?.data?.map((test, index) => (
                    <tr key={index}>
                      <td>{test.id}</td>
                      <td>
                        <img src={imgBaseUrl(test.banner!)} alt={test.title} width="50"/>
                      </td>
                      <td>{test.title}</td>
                      <td className={"mw-300px"}>{test.description}
                      </td>
                      <td>{test.is_active ? 'Aktiv' : 'Passiv'}</td>
                      <td>{test.question_count}</td>
                      <td className={"mw-100px"}>
                        <div className={"d-flex flex-wrap gap-2"}>
                          <button onClick={() => setSelectedTest(test?.id)} className={"btn btn-sm btn-light-primary"}>
                            <KTIcon iconName={"pencil"} className={"fs-4"}/>
                            Tahrirlash
                          </button>
                          <button className="btn btn-icon btn-danger btn-sm me-1" onClick={() => {
                            handleDeleteClick(test.id)
                          }}>
                            <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"}/>
                          </button>

                          <Link to={`/courses/${courseId}/lesson/${lessonId}/test/${test?.id}/question/create`}
                                onClick={() => setSelectedTest(test?.id)} className={"btn btn-sm btn-secondary"}>
                            <KTIcon iconName={"question-2"} className={"fs-4"}/>
                            Savol qo'shish
                          </Link>
                        </div>
                      </td>
                    </tr>
                ))}
                </tbody>
              </table>
            </div>

            <Pagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
            />
          </div>
        </div>
      </div>
  )
}
